import { useContext, useEffect, useState } from 'react';
import { Box, Breadcrumbs, Typography, Table, TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, Pagination, Modal, TextField, Tabs, Tab, Switch } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { deleteAllCandidates, getById } from '../../../../services/masterService';
import { Container, MainContainer } from '../../../../components';
import { Menu } from '../Menu/Menu';
import RadiusButton from '../../../../components/RadiusButton'
import { useToaster } from '../../../../providers/ToasterProvider';
import dayjs from '../../../../config/dayjs';
import { changeDisabledStatus, changeTechnicalIssueOccurredStatus, clearLoggedInCount, deleteCandidate, getListAllByPage } from '../../../../services/candidateService';
import { deleteAllProcessingCandidates, deleteProcessingCandidate, getListByPageByProjectMasterId, getProcessingDataByProjectMasterId } from '../../../../services/processingCandidateService';

import SEARCH_ICON from '../../../../assets/images/search-icon.svg';
import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
import ARROW_LEFT from '../../../../assets/images/back.svg';

import './Candidates.scss';
import { ProjectContext } from '../../../../providers/projectProvider';
import { UploadCandidateModal } from '../UploadCandidateModal/UploadCandidateModal';
import { UpdateCandidateModal } from '../UpdateCandidateModal/UpdateCandidateModal';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

let timer = null;

const errorColumns = [
    { id: 'rollNo', label: 'Roll No', minWidth: 120 },
    { id: 'candidateName', label: 'Candidate Name', minWidth: 160 },
    { id: 'photoPath', label: 'Photo Path', minWidth: 140 },
    { id: 'signaturePath', label: 'Signature Path', minWidth: 140 },
    { id: 'errors', label: 'Errors', minWidth: 400 },
];
const processingColumns = [
    { id: 'rollNo', label: 'Roll No', minWidth: 120 },
    { id: 'candidateName', label: 'Candidate Name', minWidth: 160 },
    { id: 'dob', label: 'Dob', minWidth: 110 },
    { id: 'examHallName', label: 'Exam Hall Name', minWidth: 180 },
    { id: 'serverId', label: 'Server Id', minWidth: 140 },
    { id: 'venueId', label: 'Venue Id', minWidth: 140 },
    { id: 'languages', label: 'Languages', minWidth: 140 },
    { id: 'scribeRequired', label: 'Scribe Required', minWidth: 140 },
    { id: 'actions', label: 'Actions', minWidth: 140 },
];
const columns = [
    { id: 'rollNo', label: 'Roll No', minWidth: 120 },
    { id: 'candidateName', label: 'Candidate Name', minWidth: 160 },
    { id: 'dob', label: 'Dob', minWidth: 110 },
    { id: 'examHallName', label: 'Exam Hall Name', minWidth: 180 },
    { id: 'serverId', label: 'Server Id', minWidth: 140 },
    { id: 'venueId', label: 'Venue Id', minWidth: 140 },
    { id: 'languages', label: 'Languages', minWidth: 140 },
    { id: 'scribeRequired', label: 'Scribe Required', minWidth: 140 },
    // { id: 'loggedInCount', label: 'Logged In Count', minWidth: 140 },
    // { id: 'isDisabled', label: 'Disabled', minWidth: 140 },
    // { id: 'technicalIssueOccurred', label: 'Technical Issue Occurred', minWidth: 140 },
    { id: 'actions', label: 'Actions', minWidth: 140 },
];
const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT);


const disableSchema = z.object({
    reason: z.string().min(1, { message: 'Disable reason is required.' }),
});


export const Candidates = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { projectDetails } = useContext(ProjectContext);
    const params = useParams();
    const projectName = params?.projectName;
    const [candidates, setCandidates] = useState([]);
    const [processingCandidates, setProcessingCandidates] = useState([]);
    const [projectMasterId, setProjectMasterId] = useState(null);
    const [projectMaster, setProjectMaster] = useState(null);
    const [drive, setDrive] = useState({
        id: null,
        driveName: 'Drive name'
    });
    const [course, setCourse] = useState({
        id: null,
        courseName: 'Course name'
    })
    const [maxPages, setMaxPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTab, setSelectedTab] = useState('approved');
    const { addNotification } = useToaster();
    const [search, setSearch] = useState('');
    const [newSearch, setNewSearch] = useState(false);
    const [candidatesChanged, setCandidateChanged] = useState(false);
    const [deleteData, setDeleteData] = useState({
        id: null,
        isVisible: false
    });
    const [deleteAllModal, setDeleteAllModal] = useState(false);
    const [uploadCandidateModalVisible, setUploadCandidateModalVisible] = useState(false);
    const [updateCandidateModalVisible, setUpdateCandidateModalVisible] = useState(false);
    const [viewProgressModelVisible, setViewProgressModelVisible] = useState(false);
    const [processingData, setProcessingData] = useState({
        rows: [],
        processingCount: 0,
        isProcessing: false
    })
    const [disableModal, setDisableModal] = useState({
        isVisible: false,
        candidateId: null,
        status: false,
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        trigger,
        reset,
    } = useForm({
        resolver: zodResolver(disableSchema),
    });

    const handleTabChange = (e, value) => {
        setSelectedTab(value);
    }

    useEffect(() => {
        const fetchConfigurationData = async () => {
            const drive = location?.state?.drive;
            const course = location?.state?.course;
            const projectMasterId = location?.state?.projectMasterId;
            if (!drive || !course || !projectMasterId) {
                if (projectName) {
                    navigate(`/${projectName}/masters`);
                }
                return;
            }
            setDrive(drive);
            setCourse(course);
            setProjectMasterId(projectMasterId);

            try {
                const result = await getById(projectMasterId);
                if (result?.code === 'OK') {
                    setProjectMaster(result.data);
                } else {
                    if (projectName) {
                        navigate(`/${projectName}/masters`);
                    }
                    return;
                }
            } catch (error) {
                const code = error?.response?.data?.code;
                if (projectName) {
                    navigate(`/${projectName}/masters`);
                }
                console.log('There is an error while getting project master data', code);
            }
        }
        fetchConfigurationData();
    }, [location])

    useEffect(() => {
        const getProcessingData = async () => {
            if (!projectMasterId) return;
            try {
                const res = await getProcessingDataByProjectMasterId(projectMasterId);
                if (res.code === 'OK') {
                    setProcessingData({
                        isProcessing: res.data.isProcessing,
                        processingCount: res.data.processingCount,
                        rows: res.data.rows
                    })
                } else {
                    addNotification('Something bad happened on server.');
                }
            } catch (error) {
                console.log('There is an error while getting processing candidates list', error);
                addNotification('Something bad happened on server.');
            }
        }
        getProcessingData();
    }, [viewProgressModelVisible]);

    useEffect(() => {
        fetchRequiredData(projectMasterId);
    }, [projectMasterId, selectedTab, newSearch, currentPage, candidatesChanged]);

    const fetchRequiredData = async (masterId) => {
        if (!masterId) return;
        if (selectedTab === 'approved') {
            try {
                const res = await getListAllByPage(masterId, search, currentPage, limit);
                if (res.code === 'OK') {
                    const count = res.data.count;
                    const rows = res.data.rows ?? [];
                    setCandidates(rows.map((candidate) => {
                        const dateOfBirth = dayjs(candidate.dob);
                        candidate.dob = dateOfBirth.format('DD-MM-YYYY');
                        return candidate;
                    }));
                    const pages = Math.ceil(count / limit);
                    setMaxPages(pages);
                } else {
                    addNotification('Something bad happened on server.');
                }
            } catch (error) {
                console.log('There is an error while getting processing candidates list', error);
                addNotification('Something bad happened on server.');
            }
        } else {
            try {
                const res = await getListByPageByProjectMasterId(masterId, search, currentPage, limit);
                if (res.code === 'OK') {
                    const count = res.data.count;
                    const rows = res?.data?.rows ?? [];
                    setProcessingCandidates(rows.map((candidate) => {
                        const dateOfBirth = dayjs(candidate.dob);
                        candidate.dob = dateOfBirth.format('DD-MM-YYYY');
                        return candidate;
                    }));
                    const pages = Math.ceil(count / limit);
                    setMaxPages(pages);
                } else {
                    addNotification('Something bad happened on server.');
                }
            } catch (error) {
                console.log('There is an error while getting processing candidates list', error);
                addNotification('Something bad happened on server.');
            }
        }
    }

    const onSearch = (e) => {
        setSearch(e.target.value);
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            setCurrentPage(1);
            setNewSearch(!newSearch);
        }, 400);
    }
    const handlePageChange = (e, value) => {
        setCurrentPage(value);
    };

    const onGoToMasters = () => {
        navigate(`/${projectName}/masters`);
    }
    const onUploadCandidate = () => {
        setUploadCandidateModalVisible(true);
    }
    const onUpdateRecords = () => {
        setUpdateCandidateModalVisible(true);
    }
    const onViewProgress = () => {
        setViewProgressModelVisible(true);
    }
    const onDeleteCandidate = (candidateId) => {
        setDeleteData({
            id: candidateId,
            isVisible: true
        });
    }
    const onCloseDeleteCandidateModal = () => {
        setDeleteData({
            id: null,
            isVisible: false,
        });
    }
    const onConfirmDeleteCandidate = async () => {
        if (!deleteData.id) return;
        try {
            if (selectedTab === 'approved') {
                const res = await deleteCandidate(deleteData.id);
                if (res.code === 'OK') {
                    setCandidates(
                        candidates.filter((candidate) => candidate.id !== deleteData.id)
                    );
                    setDeleteData({
                        id: null,
                        isVisible: false,
                    });
                }
            } else {
                const res = await deleteProcessingCandidate(deleteData.id);
                if (res.code === 'OK') {
                    setProcessingCandidates(
                        processingCandidates.filter((candidate) => candidate.id !== deleteData.id)
                    );
                    setDeleteData({
                        id: null,
                        isVisible: false,
                    });
                }

            }
        } catch (error) {
            const code = error?.response?.data?.code;
            if (code === 'EXAM_ENABLED_NOT_DELETED') {
                addNotification('Exam enabled for this master.', 'warning');
            }
            console.log('There is an error while deleting master candidates', error);
        }
    }
    const onDeleteAllCandidates = async () => {
        setDeleteAllModal(true);
    }
    const onConfirmDeleteCandidates = async () => {
        try {
            if (selectedTab === 'approved') {
                const res = await deleteAllCandidates(projectMasterId);
                if (res.code === 'OK') {
                    setCandidates([]);
                    setMaxPages(1);
                    setCurrentPage(1);
                    setDeleteAllModal(false);
                }
            } else {
                const res = await deleteAllProcessingCandidates(projectMasterId);
                if (res.code === 'OK') {
                    setProcessingCandidates([]);
                    setMaxPages(1);
                    setCurrentPage(1);
                    setDeleteAllModal(false);
                }
            }
        } catch (error) {
            const code = error?.response?.data?.code;
            if (code === 'EXAM_ENABLED_NOT_DELETED') {
                addNotification('Exam enabled for this master.', 'warning');
            }
            console.log('There is an er ror while deleting master candidates', error);
        }
    }

    const handleClearLoggedInCount = async (candidateId) => {
        try {
            const result = await clearLoggedInCount(candidateId);
            if (result.code === "OK") {
                addNotification('Logged in count cleared successfully.', 'success')
                setCandidates(
                    candidates.map((candidate) => {
                        if (candidate.id === candidateId) {
                            candidate.loggedInCount = 0;
                        }
                        return candidate;
                    })
                );
            }
        } catch (error) {
            console.log('There is an error while clearing logged in count', error);
            addNotification('Logged in count does not cleared.', 'danger');
        }
    }
    const handleDisabledChange = async (rowIndex, status) => {
        const candidateId = candidates[rowIndex]?.id;
        if (status) {
            setDisableModal({
                candidateId: candidateId,
                status: status,
                isVisible: true
            });
        } else {
            try {
                const result = await changeDisabledStatus(candidateId, status, '');
                if (result.code === "OK") {
                    addNotification('Disabled status updated successfully.', 'success')
                    setCandidates(
                        candidates.map((candidate) => {
                            if (candidate.id === candidateId) {
                                candidate.isDisabled = status;
                            }
                            return candidate;
                        })
                    )
                }
            } catch (error) {
                console.log('There is an error while disabling candidate', error);
            }
        }
    }
    const hideDisableModal = () => {

        reset();
        setDisableModal({
            isVisible: false,
            candidateId: null,
            status: false,
        })
    }
    const handleConfirmDisable = async (value) => {
        try {
            const reason = value.reason;
            const result = await changeDisabledStatus(disableModal.candidateId, disableModal.status, reason);
            if (result.code === "OK") {
                addNotification('Disabled status updated successfully.', 'success')
                setCandidates(
                    candidates.map((candidate) => {
                        if (candidate.id === disableModal.candidateId) {
                            candidate.isDisabled = disableModal.status;
                        }
                        return candidate;
                    })
                )
                setDisableModal({
                    isVisible: false,
                    candidateId: null,
                    status: false
                })
                reset();
            }
        } catch (error) {
            console.log('There is an error while changing disabled status', error);
            addNotification('Disabled status does not changed', 'danger');
        }
    }
    const handleTechnicalIssueOccurred = async (rowIndex, status) => {
        const candidateId = candidates[rowIndex]?.id;
        if (!candidateId) return;
        try {
            const result = await changeTechnicalIssueOccurredStatus(candidateId, status);
            if (result.code === "OK") {
                addNotification('Technical issue occurred status updated successfully.', 'success')
            }
        } catch (error) {
            console.log('There is an error while changing Technical issue occurred status', error);
            addNotification('Technical issue occurred status does not changed', 'danger');
        }
    }



    const renderCandidateCell = (columnId, rowIndex) => {
        const row = candidates[rowIndex];
        switch (columnId) {
            case 'rollNo':
                return row?.['rollNo'];
            case 'candidateName':
                return row?.['candidateName'];
            case 'dob':
                return row?.['dob'];
            case 'examHallName':
                return row?.['examHall.hallName'];
            case 'serverId':
                return row?.['server.serverId'];
            case 'venueId':
                return row?.['venueId'];
            case 'languages':
                return row?.['languages']?.join(',');
            case 'scribeRequired':
                return row?.['scribeRequired'] ? 'Yes' : 'No';
            case 'loggedInCount':
                return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                    <Typography component='span'>{row?.['loggedInCount']}</Typography>
                    {row?.['loggedInCount']
                        ? <RadiusButton
                            variant='contained'
                            size='small'
                            onClick={() => handleClearLoggedInCount(row.id)}
                        >
                            Clear
                        </RadiusButton>
                        : null}
                </Box>
            case 'isDisabled':
                return <Switch
                    checked={row?.['isDisabled']}
                    onChange={() => handleDisabledChange(rowIndex, !row.isDisabled)}
                />
            case 'technicalIssueOccurred':
                return <Switch
                    defaultChecked={row?.['technicalIssueOccurred']}
                    onChange={(e, v) => handleTechnicalIssueOccurred(rowIndex, v)}
                />
            case 'actions':
                return projectMaster?.enabledBy
                    ? null
                    : <Typography
                        sx={{
                            cursor: 'pointer',
                            color: 'error.main',
                            fontSize: 14
                        }}
                        onClick={() => onDeleteCandidate(row.id)}
                    >Delete</Typography>;
            default:
                return row[columnId];
        }
    }
    const renderPendingCandidateCell = (columnId, rowIndex) => {
        const row = processingCandidates[rowIndex];
        switch (columnId) {
            case 'rollNo':
                return row?.['rollNo'];
            case 'candidateName':
                return row?.['candidateName'];
            case 'dob':
                return row?.['dob'];
            case 'examHallName':
                return row?.['examHallName'];
            case 'serverId':
                return row?.['serverId'];
            case 'venueId':
                return row?.['venueId'];
            case 'languages':
                return row?.['languages']?.join(',');
            case 'scribeRequired':
                return row?.['scribeRequired'] ? 'Yes' : 'No';
            case 'actions':
                return <Typography variant='body1'
                    sx={{
                        cursor: 'pointer',
                        color: 'error.main'
                    }}
                    onClick={() => onDeleteCandidate(row.id)}
                >Delete</Typography>;
            default:
                return row[columnId];
        }
    }
    const renderErrorColumns = (columnId, rowIndex) => {
        const row = processingData.rows[rowIndex];
        const errors = [];
        if (row.photoPathErr) {
            errors.push('Photo image not found on provided path')
        }
        if (row.signaturePathErr) {
            errors.push('Signature Image not found on provided path')
        }
        switch (columnId) {
            case 'rollNo':
                return row?.['rollNo'];
            case 'candidateName':
                return row?.['candidateName'];
            case 'photoPath':
                return row?.['photoPath'];
            case 'signaturePath':
                return row?.['signaturePath'];
            case 'errors':
                return errors.join(',');
            default:
                return row[columnId];
        }
    }

    return (
        <MainContainer sx={{ bgcolor: 'red' }}>
            <Menu>
                <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                    <Typography color="text.primary" sx={{ fontWeight: 400, textTransform: 'capitalize' }}>{projectDetails?.projectName}</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW} alt=''></img>
                    </Box>

                    <Typography color="text.primary" sx={{ fontWeight: 500 }}>Candidates List</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW_OPEN} alt='' ></img>
                    </Box>
                </Breadcrumbs>
            </Menu>
            <Container sx={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <h1 className='title'>Candidates List</h1>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.5,
                    mb: 1.5
                }}>
                    <TextField
                        size='small'
                        label="Drive Name"
                        variant="outlined"
                        value={drive?.['driveName']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 220,
                            bgcolor: 'background.base'
                        }}
                    />
                    <TextField
                        size='small'
                        label="Course Name"
                        variant="outlined"
                        value={course?.['courseName']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 220,
                            bgcolor: 'background.base'
                        }}
                    />
                    <RadiusButton sx={{
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        ml: 'auto'
                    }} color="secondary"
                        type="submit"
                        variant='contained'
                        disabled={!!projectMaster?.enabledBy}
                        onClick={onUploadCandidate}
                    >
                        Upload Candidates
                    </RadiusButton>
                    <RadiusButton
                        variant='contained'
                        color='grey'
                        onClick={onGoToMasters}
                        startIcon={<img src={ARROW_LEFT} alt='' />}
                    >
                        Go back
                    </RadiusButton>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={selectedTab} onChange={handleTabChange}>
                        <Tab label="approved" id='approved' value='approved' />
                        <Tab label="pending" id='pending' value='pending' />
                    </Tabs>
                </Box>

                <Box style={{ border: '1px solid #BDBDBD' }} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    bgcolor: 'background.base',
                    px: 1.5,
                    py: 2
                }}>
                    <div className="search-header-wrapper" style={{ marginBottom: 12 }}>
                        <div className='search-wrapper'>
                            <input type='text' className='search-box' value={search} onChange={onSearch} placeholder='Search...' />
                            <img className='search-icon' src={SEARCH_ICON} alt='' />
                        </div>
                        {selectedTab === 'pending' && processingCandidates.length
                            ? <RadiusButton
                                sx={{
                                    textTransform: 'uppercase',
                                    fontWeight: 500,
                                }}
                                color='secondary'
                                variant='contained'
                                onClick={onUpdateRecords}
                            >
                                Update records
                            </RadiusButton>
                            : null}
                        <RadiusButton
                            sx={{
                                textTransform: 'uppercase',
                                fontWeight: 500,
                            }}
                            color='secondary'
                            variant='contained'
                            onClick={onViewProgress}
                        >
                            View progress
                        </RadiusButton>
                        <RadiusButton
                            sx={{
                                textTransform: 'uppercase',
                                fontWeight: 500,
                            }}
                            color='secondary'
                            variant='contained'
                            disabled={!!projectMaster?.enabledBy}
                            onClick={onDeleteAllCandidates}
                        >
                            Delete all
                        </RadiusButton>
                    </div>

                    {selectedTab === 'approved'
                        ? <Paper sx={{
                            width: '100%',
                            overflow: 'hidden',
                            bgcolor: 'background.base',
                            maxHeight: 'calc(100vh - 305px)',
                            maxWidth: 'calc(100vw - 160px)',
                            borderRadius: 1,
                            mb: 4
                        }}>
                            <TableContainer sx={{
                                px: 1,
                                pb: 1,
                                maxHeight: 'inherit',
                                maxWidth: 'inherit',
                                border: '1px solid',
                                borderColor: 'primary.main',
                                borderRadius: 1
                            }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    sx={{
                                                        color: 'primary.main'
                                                    }}
                                                    key={column.id}
                                                    align='center'
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!candidates?.length
                                            ? <TableRow sx={{ mx: 'auto', p: 2, color: 'grey.500' }}>
                                                <TableCell colSpan={9} sx={{ border: 'none', textAlign: 'center' }}>
                                                    No records available
                                                </TableCell>
                                            </TableRow>
                                            : candidates.map((row, rowIndex) => {
                                                return (
                                                    <TableRow hover={false} role="checkbox" key={rowIndex}>
                                                        {columns.map((column, index) => {
                                                            return <TableCell key={column.id} align='center' sx={{
                                                                px: 1.5,
                                                                py: 0.75
                                                            }}>
                                                                {renderCandidateCell(column.id, rowIndex)}
                                                            </TableCell>
                                                        })}
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        : <Paper sx={{
                            width: '100%',
                            overflow: 'hidden',
                            bgcolor: 'background.base',
                            maxHeight: 'calc(100vh - 305px)',
                            maxWidth: 'calc(100vw - 160px)',
                            borderRadius: 1,
                            mb: 4
                        }}>
                            <TableContainer sx={{
                                px: 1,
                                pb: 1,
                                maxHeight: 'inherit',
                                maxWidth: 'inherit',
                                border: '1px solid',
                                borderColor: 'primary.main',
                                borderRadius: 1
                            }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {processingColumns.map((column) => (
                                                <TableCell
                                                    sx={{
                                                        color: 'primary.main'
                                                    }}
                                                    key={column.id}
                                                    align='center'
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!processingCandidates?.length
                                            ? <TableRow sx={{ mx: 'auto', p: 2, color: 'grey.500' }}>
                                                <TableCell colSpan={9} sx={{ border: 'none', textAlign: 'center' }}>
                                                    No records available
                                                </TableCell>
                                            </TableRow>
                                            : processingCandidates.map((row, rowIndex) => {
                                                return (
                                                    <TableRow hover={false} role="checkbox" key={rowIndex}>
                                                        {processingColumns.map((column, index) => {
                                                            return <TableCell key={column.id} align='center' sx={{
                                                                px: 1.5,
                                                                py: 0.75
                                                            }}>
                                                                {renderPendingCandidateCell(column.id, rowIndex)}
                                                            </TableCell>
                                                        })}
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    }
                    <Pagination sx={{ mt: 'auto' }} count={maxPages} page={currentPage} onChange={handlePageChange} shape="rounded" />
                </Box>


                {/* view progress modal */}
                <Modal open={viewProgressModelVisible} className='backdrop' hideBackdrop={true} onClose={() => setViewProgressModelVisible(false)}>
                    <Box className='modal-container' sx={{
                        maxWidth: processingData.isProcessing && processingData.rows.length ? 480 : 720,
                        p: 2.5,
                    }}>
                        {processingData.isProcessing
                            ? <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 2,
                            }}>
                                <Typography variant='h6' sx={{
                                    fontWeight: 400,
                                    mb: 2,
                                }}>
                                    {processingData.processingCount} records are pending to process.
                                </Typography>
                                <RadiusButton variant='outlined' onClick={() => setViewProgressModelVisible(false)}>
                                    Okay
                                </RadiusButton>
                            </Box>
                            : processingData.processingCount === 0 && !processingData.rows.length
                                ? <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2,
                                }}>
                                    <Typography variant='h6' sx={{
                                        fontWeight: 400,
                                        mb: 2,
                                    }}>
                                        All records are checked and approved.
                                    </Typography>
                                    <RadiusButton variant='outlined' onClick={() => setViewProgressModelVisible(false)}>
                                        Okay
                                    </RadiusButton>
                                </Box>
                                : <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2,
                                }}>
                                    <Typography variant='h6' sx={{
                                        fontWeight: 400,
                                        mb: 2,
                                    }}>
                                        Records with errors are
                                    </Typography>
                                    <Paper sx={{
                                        width: '100%',
                                        overflow: 'hidden',
                                        bgcolor: 'background.base',
                                        maxHeight: 'calc(100vh - 305px)',
                                        maxWidth: 'calc(100vw - 160px)',
                                        borderRadius: 1,
                                        mb: 4
                                    }}>
                                        <TableContainer sx={{
                                            px: 1,
                                            pb: 1,
                                            maxHeight: 'inherit',
                                            maxWidth: 'inherit',
                                            border: '1px solid',
                                            borderColor: 'primary.main',
                                            borderRadius: 1
                                        }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        {errorColumns.map((column) => (
                                                            <TableCell
                                                                sx={{
                                                                    color: 'primary.main'
                                                                }}
                                                                key={column.id}
                                                                align='center'
                                                                style={{ minWidth: column.minWidth }}
                                                            >
                                                                {column.label}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        processingData?.rows?.map((row, rowIndex) => {
                                                            return (
                                                                <TableRow hover={false} role="checkbox" key={rowIndex}>
                                                                    {errorColumns.map((column, index) => {
                                                                        return <TableCell key={column.id} align='center' sx={{
                                                                            px: 1.5,
                                                                            py: 0.75
                                                                        }}>
                                                                            {renderErrorColumns(column.id, rowIndex)}
                                                                        </TableCell>
                                                                    })}
                                                                </TableRow>
                                                            );
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                    <RadiusButton variant='outlined' onClick={() => setViewProgressModelVisible(false)}>
                                        Okay
                                    </RadiusButton>
                                </Box>}
                    </Box>
                </Modal>
                <UploadCandidateModal
                    projectMasterId={projectMasterId}
                    uploadCandidateModalVisible={uploadCandidateModalVisible}
                    setUploadCandidateModalVisible={setUploadCandidateModalVisible}
                    candidatesChanged={candidatesChanged}
                    setCandidatesChanged={setCandidateChanged}
                ></UploadCandidateModal>
                <UpdateCandidateModal
                    projectMasterId={projectMasterId}
                    updateCandidateModalVisible={updateCandidateModalVisible}
                    setUpdateCandidateModalVisible={setUpdateCandidateModalVisible}
                    candidatesChanged={candidatesChanged}
                    setCandidatesChanged={setCandidateChanged}
                ></UpdateCandidateModal>
                {/* delete candidate modal */}
                <Modal open={deleteData.isVisible} className='backdrop' hideBackdrop={true} onClose={() => onCloseDeleteCandidateModal()}>
                    <Box className='modal-container' sx={{
                        maxWidth: 480,
                        p: 3,
                    }}>
                        <Typography variant='h6' sx={{
                            fontWeight: 400,
                            mb: 8,
                            textAlign: 'center'
                        }}>
                            Are you sure you want to delete this candidate?
                        </Typography>

                        <div className='actions-container' style={{ justifyContent: 'center', gap: '40px' }}>
                            <RadiusButton variant='outlined' onClick={() => onCloseDeleteCandidateModal()}>
                                No
                            </RadiusButton>
                            <RadiusButton variant='contained' onClick={() => onConfirmDeleteCandidate()}>
                                Yes
                            </RadiusButton>
                        </div>
                    </Box>
                </Modal>
                {/* delete all candidate modal */}
                <Modal open={deleteAllModal} className='backdrop' hideBackdrop={true} onClose={() => setDeleteAllModal(false)}>
                    <Box className='modal-container' sx={{
                        maxWidth: 480,
                        p: 3,
                    }}>
                        <Typography variant='h6' sx={{
                            fontWeight: 400,
                            mb: 8,
                            textAlign: 'center'
                        }}>
                            Do you want to delete all candidates?
                        </Typography>

                        <div className='actions-container' style={{ justifyContent: 'center', gap: '40px' }}>
                            <RadiusButton variant='outlined' onClick={() => setDeleteAllModal(false)}>
                                No
                            </RadiusButton>
                            <RadiusButton variant='contained' onClick={() => onConfirmDeleteCandidates()}>
                                Yes
                            </RadiusButton>
                        </div>
                    </Box>
                </Modal>
                {/* Disable status update modal */}
                <Modal open={disableModal.isVisible} className='backdrop' hideBackdrop={true} onClose={hideDisableModal}>
                    <Box className='modal-container' component='form' autoComplete='off' sx={{
                        maxWidth: 480,
                        p: 3,
                    }} onSubmit={handleSubmit(handleConfirmDisable)}>
                        <Typography variant='h6' sx={{
                            fontWeight: 400,
                            mb: 1.5,
                            textAlign: 'center'
                        }}>
                            Disabled reason:
                        </Typography>
                        <TextField
                            size='small'
                            variant="outlined"
                            placeholder='Disabled reason'
                            {...register('reason')}
                            error={Boolean(errors.reason)}
                            helperText={errors.reason?.message}
                            onBlur={() => trigger('reason')}
                            sx={{
                                width: '100%',
                                bgcolor: 'background.base',
                                mb: 2.5
                            }}
                        />

                        <div className='actions-container' style={{ justifyContent: 'center', gap: '40px' }}>
                            <RadiusButton variant='outlined' onClick={hideDisableModal}>
                                Cancel
                            </RadiusButton>
                            <RadiusButton variant='contained' type='submit'>
                                Disable
                            </RadiusButton>
                        </div>
                    </Box>
                </Modal>

            </Container>
        </MainContainer >
    );
}
